import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import {
  ApproveOutcomingRequests,
  GetOutgoingHGOFilteredRequests,
  GetOutgoingHGORequests,
  GetOutgoingMonazamFilteredRequests,
  GetOutgoingMonazamRequests,
  GetOutgoingRequests,
  RejectOutcomingRequests,
} from "../../../../../Actions/RequestActions";
import { formatAmount, SuccessToast, ErrorToast } from "../../../../../Util";
import { Spinner } from "react-bootstrap";
import {
  ApproveHGO,
  GetPendingFilteredHGOs,
  GetPendingHGOs,
  RejectHGO,
} from "../../../../../Actions/AuthorizationActions";
import "./Table.css";

const Table = ({ reload, filters, setTotalPages, page, setPage }) => {
  const { userType } = useParams();
  const isMonazam = userType === "monazam";
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [processingEnrollment, setProcessingEnrollment] = useState("");
  const [processingType, setProcessingType] = useState("");

  const handleApprove = (result) => {
    SuccessToast("HGO request approved successfully.");
    if (result?.email?.sent) {
      SuccessToast("Approval email sent to HGO.");
    } else if (result?.email && result.email.error) {
      ErrorToast("Failed to send approval email to HGO.");
    }
    fetchHgoRequests();
  };

  const handleReject = (result) => {
    SuccessToast("HGO Request rejected successfully.");
    if (result?.email?.sent) {
      SuccessToast("Rejection email sent to HGO.");
    } else if (result?.email && result.email.error) {
      ErrorToast("Failed to send rejection email to HGO.");
    }
    fetchHgoRequests();
  };

  const approveRequest = (id) => {
    setProcessingEnrollment(id);
    setProcessingType("approve");
    ApproveHGO(setError, setLoading, id, handleApprove)
      .catch(() => {})
      .finally(() => {
        setProcessingEnrollment("");
        setProcessingType("");
      });
  };

  const rejectRequest = (id) => {
    setProcessingEnrollment(id);
    setProcessingType("reject");
    RejectHGO(setError, setLoading, id, handleReject)
      .catch(() => {})
      .finally(() => {
        setProcessingEnrollment("");
        setProcessingType("");
      });
  };

  const fetchFilteredHgoRequests = async () => {
    setLoading(true);
    GetPendingFilteredHGOs(
      filters,
      setError,
      setLoading,
      setData,
      page,
      setTotalPages
    );
    setPage(1);
  };

  const fetchHgoRequests = async () => {
    setLoading(true);
    GetPendingHGOs(setError, setLoading, setData, page, setTotalPages);
  };


  useEffect(() => {
    if (!filters.date) {
      fetchHgoRequests();
    } else {
      fetchFilteredHgoRequests();
    }
  }, [reload, filters, page]);

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center loading-container">
        <Spinner animation="border" className="spinner-green" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  else if (!!error) return <p>{error}</p>;
  else
    return (
      <div>
        {!error && (!data || !Array.isArray(data) || data.length === 0) ? (
          <div className="d-flex justify-content-center align-items-center loading-container">
            <div className="text-center">
              <p className="text-muted">No data available</p>
            </div>
          </div>
        ) : !error && (
          <div className="table-responsive hgo-requests-table-wrapper">
            <table className="table hgo-requests-table">
              <thead>
                <tr>
                  <th className="tableheader-txt py-3">Date</th>
                  <th className="tableheader-txt py-3">HGO Name</th>
                  <th className="tableheader-txt py-3">Enrollment Number</th>
                  <th className="tableheader-txt py-3">
                    {isMonazam ? "Actions" : "Status"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {(data && Array.isArray(data) ? data : []).map((request, index) => (
              <tr key={index}>
                <td className="tabledata-txt py-3">
                  {moment(request.createdAt).format('DD/MM/YYYY')}
                </td>
                <td className="tabledata-txt py-3">{request.name}</td>
                <td className="tabledata-txt py-3">
                  {request.user.enrollment}
                </td>
                <td className="tabledata-txt py-3">
                  {isMonazam ? (
                    request.status === "pending" ? (
                      <div className="actions-cell">
                        <button
                          className="btn btn-sm btn-approved"
                          style={{ minWidth: "100px" }}
                          disabled={processingEnrollment === request.user.enrollment}
                          onClick={() => {
                            approveRequest(request.user.enrollment);
                          }}
                        >
                          {processingEnrollment === request.user.enrollment && processingType === "approve" ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          ) : (
                            "Approve"
                          )}
                        </button>
                        <button
                          className="btn btn-sm btn-reject"
                          style={{ minWidth: "100px" }}
                          disabled={processingEnrollment === request.user.enrollment}
                          onClick={() => {
                            rejectRequest(request.user.enrollment);
                          }}
                        >
                          {processingEnrollment === request.user.enrollment && processingType === "reject" ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          ) : (
                            "Reject"
                          )}
                        </button>
                      </div>
                    ) : (
                      <div className="actions-cell">
                        <button
                          className="btn btn-sm btn-approved"
                          disabled
                        >
                          Approved
                        </button>
                      </div>
                    )
                  ) : (
                    <div className="actions-cell">
                      <button
                        className={`btn btn-sm ${request.status === "approved" ? 'btn-approved' : 'btn-pending'}`}
                        disabled
                      >
                        {request.status === "approved" ? "Approved" : "Pending"}
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        )}
      </div>
    );
};
export default Table;
